import Footer from "../../../Components/Footer"
import Header from "../../../Components/Header"
import SEForm from "./SEForm";

const CreateStockEntry = () => {
    return (
      <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
      <Header />
      <SEForm />
      {/* <Footer /> */}
      </div>
    )
  }
  
  export default CreateStockEntry
